import { render, staticRenderFns } from "./syncMonitor.vue?vue&type=template&id=6ae3be80"
import script from "./syncMonitor.vue?vue&type=script&lang=js"
export * from "./syncMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports